<template>
  <div>
    <div
      data-ix="hide-fixed-top-wrapper"
      class="w-hidden-small w-hidden-tiny fixed-block-top-wrapper"
    >
      <div class="w-container container with-fixed-block">
        <div class="fixed-block-wrapper">
          <a
            href="#"
            data-ix="close-fixed-bar"
            class="w-inline-block fixed-block-close-button"
          >
            <img
              src="/images/Icon-close-thin.png"
              class="close-icon"
            >
          </a>
          <Sidebar />
        </div>
      </div>
    </div>
    <Navbar />
    <div class="w-section page-header blog">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay default"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="w-editable page-header-title"
          >
            News &amp;&nbsp;Updates
          </h1>
        </div>
      </div>
      <BlogPostList :posts="posts" />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@/components/TheNavbar'
import Sidebar from '@/components/TheSidebar'
import Footer from '@/components/TheFooter'
import BlogPostList from '@/components/BlogPostList'

export default {
  name: 'Blog',
  components: {
    Navbar,
    Sidebar,
    Footer,
    BlogPostList,
  },
  computed: mapGetters({
    posts: 'allPosts',
  }),
  created() {
    this.$store.dispatch('fetchPosts').then(() => {})
  },
  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },
  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },
}
</script>
